import { MAPPED_CONTENT_TYPES } from "../../../shared/constants/analytics";

export const getLivePlayerMetaData = (programDetailsRef, playbackType, isRestartedStream) => {
  if (programDetailsRef.current?.metadata && programDetailsRef.current?.channel) {
    return {
      isItemLive: true,
      playbackType,
      mappedContentType: isRestartedStream ? MAPPED_CONTENT_TYPES.RESTART : null,
      metadata: {
        ...programDetailsRef.current?.metadata,
        channel: programDetailsRef.current?.channel,
      },
    };
  }
  return null;
};

export const getLookbackMetaData = (lookbackContent, playbackType) => {
  if (lookbackContent.current?.metadata) {
    return {
      isItemLive: true,
      playbackType,
      ...lookbackContent.current,
      mappedContentType: MAPPED_CONTENT_TYPES.LOOKBACK,
    };
  }
  return null;
};

export const getVodPlayerMetaData = (programDetailsRef, convivaContentSubType, playbackType) => {
  if (programDetailsRef.current?.[0]?.metadata && convivaContentSubType && playbackType) {
    return {
      isItemLive: false,
      playbackType,
      mappedContentType: convivaContentSubType,
      metadata: programDetailsRef.current?.[0]?.metadata,
    };
  }
  return null;
};

export const getRecordingPlayerMetaData = (programDetailsRef, playbackType, programContent, isMR) => {
  if (programDetailsRef.current?.[0]?.metadata && playbackType && programContent?.[0]) {
    return {
      playbackType,
      isItemLive: false,
      mappedContentType: isMR ? MAPPED_CONTENT_TYPES.LPVR : MAPPED_CONTENT_TYPES.CPVR,
      ...programContent[0],
      channel: {
        ...programContent?.[0]?.channel,
        ...programContent?.[0],
      },
    };
  }
  return null;
};
